import { apiClient } from "./api-client";
import type { AuthSession } from "../types/auth.types";

interface Credentials {
  email: string;
  password: string;
}

export const authApi = {
  async login(credentials: Credentials): Promise<AuthSession> {
    const { data } = await apiClient.post<AuthSession>("/auth/login", credentials);
    return data;
  },
  async register(credentials: Credentials & { role?: string }): Promise<AuthSession> {
    const { data } = await apiClient.post<AuthSession>("/auth/register", credentials);
    return data;
  },
  async refresh(token: string): Promise<AuthSession> {
    const { data } = await apiClient.post<AuthSession>("/auth/refresh", {
      refreshToken: token
    });
    return data;
  },
  async requestPasswordReset(email: string) {
    const { data } = await apiClient.post("/auth/password-reset/request", { email });
    return data as { status: string; message: string; resetToken?: string };
  },
  async resetPassword(payload: { token: string; password: string }) {
    const { data } = await apiClient.post("/auth/password-reset/confirm", payload);
    return data as { status: string; message: string };
  }
};
